(function () {
  'use strict';

  const DURATION = 300;
  const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Animate the answer's height from where it is now (so a click mid-animation reverses smoothly)
  function animateBody(item, opening) {
    const body = item.querySelector('.cwc_faq__item-body');

    if (item._cwcAnimation) {
      item._cwcAnimation.cancel();
      item._cwcAnimation = null;
    }

    if (!body || reduceMotion.matches) {
      item.open = opening;
      return;
    }

    const startHeight = item.open ? body.getBoundingClientRect().height : 0;
    if (opening) item.open = true;
    const endHeight = opening ? body.scrollHeight : 0;

    const animation = body.animate(
      [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
      { duration: DURATION, easing: EASING }
    );
    item._cwcAnimation = animation;

    animation.onfinish = function () {
      item._cwcAnimation = null;
      if (!opening) item.open = false;
    };
  }

  function setItem(item, opening) {
    if (item.classList.contains('is-open') === opening) return;
    item.classList.toggle('is-open', opening);
    animateBody(item, opening);
  }

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.cwcInit === 'true') return;
    sectionEl.dataset.cwcInit = 'true';

    const items = sectionEl.querySelectorAll('.cwc_faq__item');
    const singleOpen = sectionEl.dataset.singleOpen === 'true';

    items.forEach(function (item) {
      const summary = item.querySelector('.cwc_faq__item-title');
      if (!summary) return;

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        const opening = !item.classList.contains('is-open');

        // Close the others in the same frame so both animations run together
        if (opening && singleOpen) {
          items.forEach(function (other) {
            if (other !== item) setItem(other, false);
          });
        }

        setItem(item, opening);
      });

      // Keep the icon in sync when the browser opens an answer itself (e.g. find-in-page)
      item.addEventListener('toggle', function () {
        if (item.open && !item._cwcAnimation) item.classList.add('is-open');
      });
    });
  }

  function initAllSections() {
    document.querySelectorAll('.cwc_faq').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.cwc_faq');
    if (section) initSection(section);
  });

  // Theme Editor: open the selected question
  document.addEventListener('shopify:block:select', function (event) {
    const item = event.target;
    if (item && item.classList.contains('cwc_faq__item')) setItem(item, true);
  });
})();
